import React, { useEffect } from 'react';
import styled from 'styled-components';
import db from '../../db';
import { onSnapshot, collection, query } from "firebase/firestore";
import Jane from '../../Image/Jane.png';
import Alison from '../../Image/Alison.png';
import Rebecca from '../../Image/Rebecca.png';
import Maria from '../../Image/Maria.png';
import Derek from '../../Image/Derek.png';
import Bob from '../../Image/Bob.png';
import { Link } from 'react-router-dom';

// const Doctorsdata = [
//     {
//         id: 1, title: 'Dr. Jane Nicholson', icon: Jane,
//         specialist: 'Leading Diagnostic Doctor',
//         Review: '+500 Happy patients',
//         Address: 'iMedical Central Clinic, LA'
//     },
//     {
//         id: 2, title: 'Dr. Rebecca Flows', icon: Rebecca,
//         specialist: 'Consultant Dentist',
//         Review: '+320 Happy patients',
//         Address: 'iMedical Central Clinic, LA'
//     },
//     {
//         id: 3, title: 'Dr. Maria Anderson', icon: Maria,
//         specialist: 'Leading Diagnostic Doctor',
//         Review: '+900 Happy patients',
//         Address: 'iMedical Central Clinic, LA'
//     },
//     {
//         id: 4, title: 'Dr. Derek Mendes', icon: Derek,
//         specialist: 'Consultant Dentist',
//         Review: '+320 Happy patients',
//         Address: 'iMedical Central Clinic, LA'
//     },
//     {
//         id: 5, title: 'Dr. Bob Singer', icon: Bob,
//         specialist: 'Leading Diagnostic Doctor',
//         Review: '+500 Happy patients',
//         Address: 'iMedical Central Clinic, LA'
//     },
//     {
//         id: 6, title: 'Dr. Alison Pretty', icon: Alison,
//         specialist: 'Leading Diagnostic Doctor',
//         Review: '+500 Happy patients',
//         Address: 'iMedical Central Clinic, LA'
//     },
// ];

const Doctors = () => {
    const [Doctorsdata, setDoctorsdata] = React.useState([])


    useEffect(() => {
        const q = query(collection(db, "Doctorinformation"))
        const unsub = onSnapshot(q, (querySnapshot) => {
            setDoctorsdata(querySnapshot.docs.map(d => d.data()))
        });
        return () => unsub();
    }, []);

    return (
        <DoctorInfo>
            <HeaderContainer>
                <Heading>
                    Our Qualified Doctors
                </Heading>
                <SeeAllButton>
                    <Link to='/doctor-info' style={{ textDecoration: 'none' }}>
                        See All Doctors
                    </Link>
                </SeeAllButton>
            </HeaderContainer>
            <DoctorCard>
                {Doctorsdata.map(doctor => (
                    <InfoCard key={doctor.id}>
                        <CardIcon src={Maria} alt={doctor.doctorname} />
                        <CardHeading>{doctor.doctorname}</CardHeading>
                        <Specialist>{doctor.specialict}</Specialist>
                        <Review>{doctor.happyclients}</Review>
                        <Address>{doctor.Address}</Address>
                    </InfoCard>
                ))}
            </DoctorCard>
        </DoctorInfo>
    );
};

export default Doctors;

const DoctorInfo = styled.div`
display: flex;
flex-direction: column;
align-items: center;
padding: 20px;
background: #CF7D4E0D;
`;

const HeaderContainer = styled.div`
    display: flex;
    justify-content: space-between;
    width: 80%;
    margin: auto;
    margin-bottom: 20px;
    align-items: center;

    @media (max-width: 768px) {
        width: 100%;
        font-size:20px;
    }
`;

const Heading = styled.h1`
font-family: Poppins;
font-size: 48px;
font-weight: 700;
letter-spacing: 0em;
text-align: left;
margin-bottom: 20px;

@media (max-width: 768px) {
    font-size: 26px;
    text-align: center;
}
`;

const DoctorCard = styled.div`
display: flex;
flex-wrap: wrap;
gap: 20px;
justify-content: center;
width: 100%;
`;

const InfoCard = styled.div`
width: 25%;
border-radius: 30px;
padding: 20px;
margin-bottom: 20px;
cursor: pointer;
background-color: white;
transition: background 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;

    &:hover {
        background: white;
        box-shadow: 0px 35px 55px -12px #AA470F42;
    }

    @media (max-width: 768px) {
        width: 100%;
    }
`;

const CardIcon = styled.img`
    width: 100px;
    height: 100px;
    radius: 150px;
`;

const CardHeading = styled.h3`
    font-family: Poppins;
    font-size: 24px;
    font-weight: 600;
    line-height: 27px;
    letter-spacing: 0em;
    text-align: left;
    margin-top: 10px;
    color: black;

    @media (max-width: 768px) {
        font-size: 20px;
    }
`;

const Specialist = styled.p`
    font-family: Poppins;
    font-size: 16px;
    font-weight: 500;
    line-height: 18px;
    letter-spacing: 0em;
    text-align: left;
    color: #06212699;
    padding: 10px;
    margin: 10px 0;

    @media (max-width: 768px) {
        font-size: 14px;
    }
`;

const Review = styled.p`
    font-family: Poppins;
    font-size: 18px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;
    color: #0F97B5;
    padding: 10px;
    margin: 10px 0;

    @media (max-width: 768px) {
        font-size: 16px;
    }
`;

const Address = styled.p`
    font-family: Poppins;
    font-size: 16px;
    font-weight: 500;
    line-height: 18px;
    letter-spacing: 0em;
    text-align: left;
    color: #06212699;
    padding: 10px;
    margin: 10px 0;

    @media (max-width: 768px) {
        font-size: 14px;
    }
`;

const SeeAllButton = styled.button`
    background: #CF7D4E;
    color: white !important;
    width: 254px;
    height: 67px;
    padding: 16px 32px;
    border-radius: 55px;
    border: 2px solid #CF7D4E;
    font-family: Poppins;
    font-size: 18px;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: center;
    cursor: pointer;
    transition: background 0.3s ease-in-out, color 0.3s ease-in-out;

    &:hover {
        background: #FFF;
        color: #CF7D4E;
    }

    @media (max-width: 768px) {
        width: 20%;
        font-size: 14px;
        height: 50px;
        padding:0;
    }
    @media (max-width: 1100px) {
        width: 30%;
        font-size: 15px;
        height: 60px;
        padding:0;
    }
`;
